import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  EmailCheckGuard,
  HomeComponent, HeaderComponent, OtpComponent,LandingComponent
} from './index';

export const appRoutes: Routes = [
  { path: '', component: LandingComponent, pathMatch: 'full' },
  { path: 'accountOpening', component: LandingComponent },
  { path: 'home', component: HomeComponent,
  canActivate: [EmailCheckGuard]  },
  { path: 'home/:id', component: HomeComponent  },
  { path: 'otp/:oldApp', component: OtpComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
